import { api } from "./api";

export type FeedbackKind = "question" | "idea" | "bug" | "other";
export type FeedbackStatus = "new" | "seen" | "in_progress" | "done" | "declined";

export type ChatMessage = {
  role: "user" | "assistant" | "system";
  content: string;
};

export type ChatRequest = {
  message: string;
  history: ChatMessage[];
};

export type ChatResponse = {
  reply: string;
  sources: string[];
  powered_by: "claude" | "faq" | "fallback";
};

export type FeedbackItem = {
  id: string;
  agent_id: string;
  kind: FeedbackKind;
  status: FeedbackStatus;
  subject: string | null;
  message: string;
  chat_context: ChatMessage[];
  admin_reply: string | null;
  admin_reply_at: string | null;
  created_at: string;
  updated_at: string;
};

export type FeedbackItemForAdmin = FeedbackItem & {
  agent_code: string | null;
  agent_name: string | null;
};

export type FeedbackCreate = {
  kind?: FeedbackKind;
  subject?: string | null;
  message: string;
  chat_context?: ChatMessage[];
};

export const sendChat = (payload: ChatRequest) =>
  api.post<ChatResponse>("/agent/chat", payload);

export const submitFeedback = (payload: FeedbackCreate) =>
  api.post<FeedbackItem>("/agent/feedback", payload);

export const listMyFeedback = () =>
  api.get<{ items: FeedbackItem[] }>("/agent/feedback");

export const deleteMyFeedback = (id: string) =>
  api.delete<void>(`/agent/feedback/${id}`);

// Admin
export const listAdminFeedback = (status?: FeedbackStatus) => {
  const q = status ? `?status=${status}` : "";
  return api.get<{ items: FeedbackItemForAdmin[]; new_count: number }>(
    `/admin/feedback${q}`,
  );
};

export const updateAdminFeedback = (
  id: string,
  payload: { status?: FeedbackStatus; admin_reply?: string | null },
) => api.put<FeedbackItemForAdmin>(`/admin/feedback/${id}`, payload);
